import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, Select, InputNumber, Switch, Divider, message } from 'antd';
import { MuscleGroup, ExerciseDifficultyLevel } from '@wellverse/shared-ts';
import { ExerciseLanguageTabs, normalizeExerciseTranslations } from './LanguageTabs';
import { ExerciseClassificationFields } from './ClassificationFields';

export const ExerciseCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'exercises' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish({
        ...values,
        translations: normalizeExerciseTranslations(values.translations),
      });
      message.success('Exercise created');
      push('/exercises');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create exercise');
    }
  };

  return (
    <Create resource="exercises" saveButtonProps={{ onClick: () => formProps.form?.submit() }}>
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <ExerciseLanguageTabs />

        <Divider orientation="left" plain>
          Shared
        </Divider>

        <Form.Item label="Muscle Groups" name="muscleGroups" rules={[{ required: true }]}>
          <Select mode="multiple" placeholder="Select muscle groups">
            {Object.values(MuscleGroup).map((g) => (
              <Select.Option key={g} value={g}>{g}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Difficulty Level" name="difficultyLevel" initialValue={ExerciseDifficultyLevel.BEGINNER}>
          <Select placeholder="Select difficulty">
            {Object.values(ExerciseDifficultyLevel).map((d) => (
              <Select.Option key={d} value={d}>{d}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Video URL" name="videoUrl">
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item label="Image URL" name="imageUrl">
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item label="Calories Per Rep" name="caloriesPerRep">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Compound" name="isCompound" valuePropName="checked" initialValue={false}>
          <Switch />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>

        <ExerciseClassificationFields />
      </Form>
    </Create>
  );
};
